import { render, staticRenderFns } from "./EventCardFront.vue?vue&type=template&id=69cfa493&scoped=true&lang=pug&"
import script from "./EventCardFront.vue?vue&type=script&lang=js&"
export * from "./EventCardFront.vue?vue&type=script&lang=js&"
import style0 from "./EventCardFront.vue?vue&type=style&index=0&id=69cfa493&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cfa493",
  null
  
)

component.options.__file = "EventCardFront.vue"
export default component.exports